import { render } from "./TheManager.vue?vue&type=template&id=328b699c"
import script from "./TheManager.vue?vue&type=script&lang=js"
export * from "./TheManager.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__